<template>
  <el-collapse v-model="activeName" accordion class="homework-list-collapse">
    <el-collapse-item
      v-for="homework in homeworkList"
      :key="homework.id"
      :name="homework.index"
      class="homework-list-collapse-item"
    >
      <template slot="title">
        <div class="homework-title">
          <i class="el-icon-document homework-title-icon"></i>
          <span class="title-text">{{ homework.name }}</span>
          <span class="expire-time">{{ homework.deadline }}</span>
        </div>
      </template>
      <div class="homework-content">
        <div class="homework-content-description">Homework Description:</div>
        <MarkdownDisplay :value="homework.description" withMaxHeight />
        <FileDownloadCard v-if="homework.attachment" :href="homework.attachment" />
        <div class="homework-content-teacher-section"></div>
      </div>
      <div class="button-group">
        <el-button
          type="danger"
          v-if="$store.state.userPower === 'A'"
          round
          @click="handleDelete(homework)"
        >Delete</el-button>
        <router-link :to="'/class/'+ $route.params.class_id + '/homeworks/' + homework.id">
          <el-button type="primary" round>View More...</el-button>
        </router-link>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import MarkdownDisplay from "@/atoms/MarkdownDisplay.vue";
import FileDownloadCard from "@/atoms/FileDownloadCard.vue";
import { deleteHomeworkById } from "@/api";

export default {
  name: "HomeworkList",
  components: {
    MarkdownDisplay,
    FileDownloadCard
  },
  data() {
    return {
      activeName: "1"
    };
  },
  props: {
    homeworkList: Array
  },
  methods: {
    handleDelete: function(homework) {
      this.$confirm(
        `Delete homework "${homework.name}". Are you sure?`,
        "Warning",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          deleteHomeworkById(homework.id).then(res => {
            if (res === "succeed") {
              this.$message({
                type: "success",
                message: "Delete Success!"
              });
              this.$emit("refresh-list");
            } else {
              this.$message({
                type: "error",
                message: "Network error. Please try again."
              })
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled"
          });
        });
    }
  }
};
</script>

<style lang="scss">
.homework-list-collapse {
  border: none !important;
}
.homework-list-collapse-item {
  margin: 8px 0;
  border-radius: 12px;
  overflow: hidden;
  &:hover,
  &:focus,
  &.is-active {
    box-shadow: 0 0 5px #909399;
  }
  * {
    border: none !important;
  }
}
.el-collapse-item__header {
  padding: 8px 16px;
  &.is-active {
    background-color: #e4f7fb;
  }
  .homework-title {
    flex-grow: 1;
    display: flex;
    .homework-title-icon {
      line-height: inherit;
      padding-right: 12px;
    }
    .title-text {
      font-size: 16px;
      font-weight: 600;
      flex-grow: 1;
    }
    .expire-time {
      padding-right: 16px;
    }
  }
}
.homework-content {
  padding: 8px 16px;
  .homework-content-description {
    font-size: 14px;
    margin-bottom: 8px;
    color: #a2a2a2;
  }
}
.button-group {
  padding: 8px 16px;
  text-align: right;
  > * {
    margin-left: 16px;
  }
}
</style>